<template>
  <div class="page-auth">
    <div class="login-page">
      <div
        class="hidden bg-transparent lg:flex flex-col items-center justify-center"
      >
        <p class="text-white text-4xl text-center w-5/6">
          {{ displayedText }} <span class="cursor" v-if="showCursor">|</span>
        </p>
      </div>
      <div
        class="content-form flex flex-col items-center justify-center bg-transparent h-full"
      >
        <div
          class="mx-auto grid w-4/5 md:w-3/4 gap-6 bg-white py-8 px-3 rounded-15"
        >
          <div class="grid gap-2 text-center justify-items-center items-center">
            <div class="w-3/4 mb-3 flex justify-center">
              <img
                class="logo-img"
                :src="logoUrl"
                alt="cyberforceacademy logo"
                v-if="isLogoUrl"
              />
              <img
                class=""
                src="../../assets/auth/images/spec-brand-1.svg"
                alt="cyberforceacademy logo"
                v-else
              />
            </div>
            <!-- <h1 class="text-4xl font-[500] text-spect">
                            Connexion
                        </h1> -->
            <!-- <p class="text-balance">
                            Entrez vos informations pour  vous  connecter
                        </p> -->

            <!-- Login Form -->
            <form
              v-if="showMainForm"
              class="grid gap-3 px-4"
              @submit.prevent="handleSubmit"
            >
              <div>
                <label class="block font-medium text-left text-gray-700 mb-1"
                  >Email</label
                >
                <input
                  type="email"
                  v-model="formData.email"
                  class="w-full px-4 py-2 input input-bordered ui-input"
                  :class="{ 'ui-input--error': errors.email }"
                  placeholder="Entrez votre adresse email"
                />
                <p
                  v-if="errors.email"
                  class="text-red-500 text-sm mt-1 text-left"
                >
                  {{ errors.email }}
                </p>
              </div>

              <!-- Password -->
              <div>
                <label class="block text-left font-medium text-gray-700 mb-1"
                  >Mot de passe</label
                >
                <div class="relative">
                  <input
                    :type="toggle.password ? 'text' : 'password'"
                    v-model="formData.password"
                    class="w-full px-4 py-2 input input-bordered ui-input"
                    placeholder="mot de passe"
                    :class="{ 'ui-input--error': errors.password }"
                  />
                  <span
                    class="absolute right-2 top-3 cursor-pointer"
                    @click="toggle.password = false"
                    v-if="toggle.password"
                    ><i class="fa fa-eye-slash"></i
                  ></span>
                  <span
                    class="absolute right-2 top-3 cursor-pointer"
                    @click="toggle.password = true"
                    v-if="!toggle.password"
                    ><i class="fa fa-eye"></i
                  ></span>
                </div>
                <p
                  v-if="errors.password"
                  class="text-red-500 text-sm mt-1 text-left"
                >
                  {{ errors.password }}
                </p>
                <div class="flex justify-end items-center">
                  <!-- <label class="label cursor-pointer gap-1">
                                        <input type="checkbox" :checked="'checked'" class="" />
                                        <span class="label-text">Se rappeler de moi</span>
                                    </label> -->
                  <a
                    href="/forgotpassword"
                    class="forgot-password label-text text-accent"
                  >
                    Mot de passe oublié ?
                  </a>
                </div>
              </div>
              <button
                type="submit"
                class="w-full flex items-center justify-center gap-3 bg-spect text-white py-3 rounded-6 hover:bg-opacity-90 transition-colors btn-disable"
                :disabled="isInvalid || isSubmit"
              >
                <span
                  v-if="isSubmit"
                  class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                ></span>
                <span> Connexion </span>
              </button>

              <!-- SSO Login Button -->
              <button
                type="button"
                @click="handleGoogleLogin"
                class="w-full flex items-center justify-center gap-3 bg-white text-gray-700 py-3 rounded-6 border border-gray-300 hover:bg-gray-50 transition-colors"
              >
                <svg
                  class="w-5 h-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path d="M9 12l2 2 4-4" />
                  <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3" />
                  <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3" />
                  <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3" />
                  <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3" />
                </svg>
                <span> Utiliser le SSO pour se connecter </span>
              </button>
              <div class="grid gap-1 text-sm">
                <div class="text-center text-sm">
                  <span class="text-gray-600">Vous n'avez pas un compte? </span>
                  <a href="/signup" class="text-accent">Inscrivez-vous ici</a>
                </div>
                <p class="text-center">ou</p>
                <div class="text-center text-sm">
                  <a
                    href="/Register-with-code"
                    class="cursor-pointer text-accent"
                  >
                    <span>S'inscrire avec un code</span>
                  </a>
                </div>
              </div>
              <div class="flex items-center justify-center">
                <span class="ml-2 text-sm text-gray-600">
                  En continuant, vous acceptez les termes de notre
                  <a
                    href="https://cyberspector.com/politique-de-confidentialite-et-de-protection-des-donnees/"
                    target="_blank"
                    class="text-accent"
                    >politique de confidentialité</a
                  >
                  et nos réglementations concernant les
                  <a
                    href="https://cyberspector.com/politique-de-confidentialite-et-de-protection-des-donnees/"
                    target="_blank"
                    class="text-accent"
                    >cookies</a
                  >
                </span>
              </div>
            </form>

            <!-- Auth Factor Selection Form -->
            <form
              v-if="showAuthFactorForm"
              class="w-full px-4"
              @submit.prevent="handleAuthFactorSubmit"
            >
              <h1 class="text-4xl font-[500] text-spect">
                Multifacteur d'authentification
              </h1>
              <p class="text-balance">
                Par quel facteur d'authentification souhaiteriez vous vous
                authentifier ?
              </p>
              <!-- Authentication Method Cards -->
              <div class="grid gap-4 mb-6">
                <!-- Application d'authentification -->
                <div
                  class="auth-factor-card"
                  :class="{
                    'auth-factor-card-active': selectedAuthFactor === 'app',
                  }"
                  @click="selectAuthFactor('app')"
                >
                  <div class="auth-factor-card-content">
                    <div class="auth-factor-icon">
                      <i class="fa fa-mobile-alt fa-2x"></i>
                    </div>
                    <div class="auth-factor-info">
                      <h3 class="auth-factor-title">
                        Application d'authentification
                      </h3>
                      <p class="auth-factor-description">
                        Utilisez votre application d'authentification pour
                        générer un code de vérification.
                      </p>
                    </div>
                    <div class="auth-factor-check">
                      <i class="fa fa-check-circle"></i>
                    </div>
                  </div>
                </div>

                <!-- Authentification par e-mail -->
                <div
                  class="auth-factor-card"
                  :class="{
                    'auth-factor-card-active': selectedAuthFactor === 'email',
                  }"
                  @click="selectAuthFactor('email')"
                >
                  <div class="auth-factor-card-content">
                    <div class="auth-factor-icon">
                      <i class="fa fa-envelope fa-2x"></i>
                    </div>
                    <div class="auth-factor-info">
                      <h3 class="auth-factor-title">
                        Authentification par e-mail
                      </h3>
                      <p class="auth-factor-description">
                        Reçois un code de vérification par e-mail pour confirmer
                        ton identité.
                      </p>
                    </div>
                    <div class="auth-factor-check">
                      <i class="fa fa-check-circle"></i>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Submit Button -->
              <button
                type="submit"
                class="w-full flex items-center justify-center gap-3 bg-spect text-white py-3 rounded-6 hover:bg-opacity-90 transition-colors btn-disable"
                :disabled="!selectedAuthFactor || isSubmit"
              >
                <span
                  v-if="isSubmit"
                  class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                ></span>
                <span> Continuer </span>
              </button>

              <!-- Back to Login -->
              <div class="text-center mt-4">
                <a
                  href="#"
                  @click.prevent="cancelAuthFactorSelection"
                  class="text-accent text-sm"
                >
                  <i class="fa fa-arrow-left mr-1"></i> Retour à la connexion
                </a>
              </div>
            </form>

            <!-- 2FA Verification Form -->
            <form
              v-if="show2FAForm"
              class="grid gap-3 px-4"
              @submit.prevent="verify2FACode"
            >
              <div class="text-center mb-4">
                <h2 class="text-2xl font-medium text-gray-800 mb-2">
                  Vérification en deux étapes
                </h2>
                <p class="text-gray-600">
                  {{
                    selectedAuthFactor === "email"
                      ? "Veuillez entrer le code de vérification qui a été envoyé à votre adresse email."
                      : selectedAuthFactor === "app"
                      ? "Veuillez entrer le code de vérification qui a été envoyé à votre application d'authentification."
                      : ""
                  }}
                </p>
              </div>

              <div>
                <label class="block font-medium text-left text-gray-700 mb-1"
                  >Code de vérification</label
                >
                <input
                  type="text"
                  v-model="verificationCode"
                  class="w-full px-4 py-2 input input-bordered ui-input text-center text-2xl tracking-widest"
                  :class="{ 'ui-input--error': errors.verificationCode }"
                  placeholder="Entrez le code"
                  maxlength="6"
                />
                <p
                  v-if="errors.verificationCode"
                  class="text-red-500 text-sm mt-1 text-left"
                >
                  {{ errors.verificationCode }}
                </p>
              </div>
              <div class="flex items-center justify-start">
                <input
                  type="checkbox"
                  v-model="rememberMe"
                  class="form-checkbox text-accent"
                />
                <span class="ml-2 text-sm text-gray-600">
                  Se souvenir de moi
                </span>
              </div>

              <button
                type="submit"
                class="w-full flex items-center justify-center gap-3 bg-spect text-white py-3 rounded-6 hover:bg-opacity-90 transition-colors btn-disable"
                :disabled="isVerifying || !verificationCode"
              >
                <span
                  v-if="isVerifying"
                  class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                ></span>
                <span> Vérifier </span>
              </button>

              <div class="text-center mt-2">
                <p class="text-gray-600 text-sm">
                  Vous n'avez pas reçu de code?
                  <a
                    href="#"
                    @click.prevent="resendVerificationCode"
                    class="text-accent"
                    >Renvoyer le code</a
                  >
                </p>
                <p class="text-gray-600 text-sm mt-2">
                  <a
                    href="#"
                    @click.prevent="cancelVerification"
                    class="text-accent"
                    >Retour à la connexion</a
                  >
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div
      class="toast toast-end my-toast fixed -right-10 bottom-0"
      v-if="isAlert"
    >
      <div class="alert alert-info toast-ctn--info">
        <span>{{ alertMessage }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getAPI } from "@/axios-api.js";

export default {
  name: "LoginView",
  data() {
    return {
      toggle: {
        password: false,
      },
      formData: {
        accountType: "personal",
        email: "",
        password: "",
      },
      errors: {
        email: null,
        password: null,
        verificationCode: null,
      },
      isSubmit: false,
      isInvalid: false,
      isAlert: false,
      alertMessage: "New message",
      txt: "Placez l'humain au coeur de votre Stratégie de Cyberdéfense", // Text to display
      displayedText: "", // Currently displayed text
      speed: 100, // Typing speed in milliseconds
      backspaceSpeed: 50, // Backspace speed
      i: 0, // Character index
      showCursor: true, // Cursor blinking
      isDeleting: false, // Backspace mode flag
      showMainForm: true,

      // 2FA related properties
      show2FAForm: false,
      verificationCode: "",
      isVerifying: false,
      tempUserData: null,
      tempTokens: null,
      rememberMe: false,
      // Auth factor selection
      selectedAuthFactor: null,
      showAuthFactorForm: false,
    };
  },
  computed: {
    isLogoUrl: {
      get() {
        const logo = localStorage.getItem("domainLogo");
        return (
          logo && logo !== "null" && logo !== "undefined" && logo.trim() !== ""
        );
      },
      set(value) {
        console.log(value);
      },
    },
    logoUrl() {
      const logo = localStorage.getItem("domainLogo");
      if (
        logo &&
        logo !== "null" &&
        logo !== "undefined" &&
        logo.trim() !== ""
      ) {
        return logo;
      }
      return "../../assets/auth/images/spec-brand-1.svg";
    },
  },
  methods: {
    validateStep2() {
      // Add validation logic for step 2
      this.errors.email = null;
      this.errors.password = null;
      let isValid = true;

      if (!this.formData.email || this.formData.email.trim() == "") {
        this.errors.email = "Le champ email est obligatoire.";
        isValid = false;
      }
      if (!this.formData.password || this.formData.password.trim() == "") {
        this.errors.password = "Le champ mot de passe est obligatoire.";
        isValid = false;
      }
      return isValid;
    },

    async handleSubmit() {
      if (this.validateStep2()) {
        this.isSubmit = true;
        await axios
          .post(`${process.env.VUE_APP_BASE_URL}accounts/login`, {
            email: this.formData.email,
            password: this.formData.password,
          })
          .then(async (response) => {
            //eslint-disable-next-line
            if (response.status == 200) {
              // Vérifier si 2FA est requise (data est un tableau de méthodes)
              const isArray = Array.isArray(response.data.data);
              const otpMethods = isArray ? response.data.data : [];

              if (response.data.success && otpMethods.length > 0) {
                // 2FA requise - Stocker les informations temporaires
                this.tempUserData = response.data;

                if (
                  otpMethods.length === 1 &&
                  (otpMethods[0] === "email" || otpMethods[0] === "app")
                ) {
                  // Une seule méthode configurée, utiliser directement
                  this.selectedAuthFactor = otpMethods[0];

                  // Afficher le formulaire de vérification
                  this.show2FAForm = true;
                  this.showMainForm = false;
                  this.isSubmit = false;
                } else if (otpMethods.length >= 2) {
                  // Plusieurs méthodes configurées, laisser l'utilisateur choisir
                  this.showAuthFactorForm = true;
                  this.show2FAForm = false;
                  this.showMainForm = false;
                  this.isSubmit = false;
                }
              } else if (response.data.data && !isArray) {
                // Pas de 2FA, connexion directe avec token
                this.completeLogin(response.data.data);
              }
            } else {
              this.isSubmit = false;
            }
          })
          .catch((error) => {
            console.log(error);
            localStorage.removeItem("token");
            if (error.response) {
              if (error.response.data.message === "Invalid Credentials") {
                this.errors.email =
                  "Adresse email ou mot de passe incorrect(e)";
              } else if (
                error.response.data.message ===
                "Your account has been blocked. Please check your email for verification code."
              ) {
                this.errors.email =
                  "Votre compte a été bloqué. Veuillez vérifier votre messagerie électronique pour obtenir le code de vérification.";
                this.isInvalid = true;
              } else {
                this.errors.email =
                  "Une erreur serveur s'est produite. Veuillez réessayer plus tard.";
                this.isInvalid = true;
              }
            }
            this.isSubmit = false;
          });
      }
    },

    // Select authentication factor
    selectAuthFactor(factor) {
      this.selectedAuthFactor = factor;
    },

    // Complete the login process after successful authentication
    async completeLogin(data) {
      const token = data.access;
      const refresh_token = data.refresh;
      const user_data = data.user;

      // Store user details in localStorage
      localStorage.setItem("token", token);
      localStorage.setItem("refresh_token", refresh_token);
      localStorage.setItem("user", user_data.id);
      localStorage.setItem("firstname", user_data.firstname);
      localStorage.setItem("lastname", user_data.lastname);
      localStorage.setItem("organisation", user_data.organisation);
      localStorage.setItem("type_account", user_data.type_account);
      localStorage.setItem("role", user_data.role);
      localStorage.setItem("image", null);

      // Fetch org color
      try {
        const response = await getAPI.get(
          `organisations/${localStorage.organisation}/`,
        );
        if (response.status === 200) {
          const primary = response.data.primary_color;
          const secondary = response.data.secondary_color;

          // Store colors in localStorage
          localStorage.setItem("primary_color", primary || "#0cbcc6");
          localStorage.setItem("secondary_color", secondary || "#132c4e");
        }
      } catch (error) {
        console.error("Error fetching organization data:", error);
      }

      // Get the redirectPath
      let redirectPath = localStorage.getItem("currentPath") || "/dashboard";

      // Check if redirectPath is '/login' and redirect to '/dashboard'
      if (redirectPath === "/login") {
        redirectPath = "/dashboard";
      }

      // Perform redirection
      window.location.href = redirectPath;
    },

    // Verify the 2FA code
    async verify2FACode() {
      // Reset error
      this.errors.verificationCode = null;

      if (!this.selectedAuthFactor) {
        this.showAlert("Veuillez sélectionner une méthode d'authentification.");
        return;
      }

      // Validate code
      if (!this.verificationCode || this.verificationCode.trim() === "") {
        this.errors.verificationCode =
          "Le code de vérification est obligatoire.";
        return;
      }

      this.isVerifying = true;

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_BASE_URL}accounts/unlock-login`,
          {
            email: this.formData.email,
            code: this.verificationCode,
            remember_device: this.rememberMe,
            method: this.selectedAuthFactor,
          },
        );

        if (response.status === 200) {
          this.tempUserData = response.data.data.user;
          this.tempTokens = {
            access: response.data.data.access,
            refresh: response.data.data.refresh,
          };
          // Complete login with the stored data
          this.completeLogin({
            access: this.tempTokens.access,
            refresh: this.tempTokens.refresh,
            user: this.tempUserData,
          });
        }
      } catch (error) {
        console.error("2FA verification error:", error);

        if (error.response && error.response.data) {
          this.errors.verificationCode =
            error.response.data.message || "Code de vérification invalide.";
        } else {
          this.errors.verificationCode =
            "Une erreur s'est produite lors de la vérification. Veuillez réessayer.";
        }

        this.isVerifying = false;
      }
    },

    // Resend verification code
    async resendVerificationCode() {
      try {
        await axios.post(
          `${process.env.VUE_APP_BASE_URL}accounts/resend-2fa-code`,
          {
            email: this.formData.email,
            method: this.selectedAuthFactor,
          },
        );

        if (this.selectedAuthFactor === "email") {
          this.showAlert(
            "Un nouveau code de vérification a été envoyé à votre adresse email.",
          );
        } else {
          this.showAlert(
            "Le code est toujours disponible dans votre application d'authentification.",
          );
        }
      } catch (error) {
        console.error("Error resending code:", error);
        this.showAlert(
          "Impossible d'envoyer un nouveau code. Veuillez réessayer plus tard.",
        );
      }
    },

    // Cancel verification and go back to login or auth factor selection
    cancelVerification() {
      this.show2FAForm = false;
      this.verificationCode = "";
      this.errors.verificationCode = null;

      // Si l'utilisateur a plusieurs méthodes, le ramener à la sélection
      const otpMethods = Array.isArray(this.tempUserData?.data)
        ? this.tempUserData.data
        : [];
      if (otpMethods.length >= 2) {
        this.showAuthFactorForm = true;
        this.selectedAuthFactor = null;
      } else {
        // Sinon, retour complet à la connexion
        this.tempUserData = null;
        this.tempTokens = null;
        this.selectedAuthFactor = null;
        this.showMainForm = true;
      }
    },

    // Show alert message
    showAlert(message) {
      this.alertMessage = message;
      this.isAlert = true;

      setTimeout(() => {
        this.isAlert = false;
      }, 5000);
    },

    // Send verification code via selected method
    async sendVerificationCode(method) {
      try {
        await axios.post(`${process.env.VUE_APP_BASE_URL}accounts/send-otp/`, {
          email: this.formData.email,
          method: method,
        });

        if (method === "email") {
          this.showAlert(
            "Un code de vérification a été envoyé à votre adresse email.",
          );
        } else if (method === "app") {
          this.showAlert(
            "Veuillez utiliser votre application d'authentification pour obtenir le code.",
          );
        }
      } catch (error) {
        console.error("Error sending 2FA code:", error);
        this.showAlert("Erreur lors de l'envoi du code. Veuillez réessayer.");
        throw error;
      }
    },

    // Handle auth factor form submission
    async handleAuthFactorSubmit() {
      // Vérifier qu'une méthode est sélectionnée
      if (!this.selectedAuthFactor) {
        this.showAlert("Veuillez sélectionner une méthode d'authentification.");
        return;
      }

      this.isSubmit = true;

      try {
        // Envoyer le code via la méthode sélectionnée
        await this.sendVerificationCode(this.selectedAuthFactor);

        // Masquer le formulaire de sélection et afficher le formulaire de vérification
        this.showAuthFactorForm = false;
        this.show2FAForm = true;
      } catch (error) {
        console.error("Error in auth factor submission:", error);
      } finally {
        this.isSubmit = false;
      }
    },

    // Cancel auth factor selection
    cancelAuthFactorSelection() {
      this.showAuthFactorForm = false;
      this.showMainForm = true;
      this.selectedAuthFactor = null;
      this.tempUserData = null;
    },

    // Handle Google login
    handleGoogleLogin() {
      // Redirect to SSO email page
      this.$router.push("/google-email");
    },

    startTyping() {
      if (!this.isDeleting && this.i < this.txt.length) {
        // Forward typing
        this.displayedText += this.txt.charAt(this.i);
        this.i++;
        setTimeout(this.startTyping, this.speed);
      } else if (this.isDeleting && this.i > 0) {
        // Backspacing
        this.displayedText = this.displayedText.slice(0, -1);
        this.i--;
        setTimeout(this.startTyping, this.backspaceSpeed);
      } else {
        // Toggle between typing and backspacing
        this.isDeleting = !this.isDeleting;
        setTimeout(this.startTyping, 1000); // Pause before changing direction
      }
    },
  },
  mounted() {
    //localStorage.setItem("token",this.$route.query.access_token);
    //this.$router.push('/dashboard');

    this.startTyping();
    setInterval(() => {
      this.showCursor = !this.showCursor; // Blinking cursor effect
    }, 500);
  },
  async beforeRouteEnter() {
    try {
      const rootUrl = window.location.host;
      console.log(rootUrl);
      const response = await axios.post(
        `${process.env.VUE_APP_BASE_URL}organisations/organisation_details`,
        {
          url_access: rootUrl,
        },
      );
      console.log(response);
      if (response.status === 200) {
        const data = response.data;
        // Only store the logo if it's not null, undefined, or empty
        if (
          data.login_logo &&
          data.login_logo !== "null" &&
          data.login_logo !== "undefined"
        ) {
          localStorage.setItem("domainLogo", data.login_logo);
        } else {
          // Remove the item if it's null to ensure fallback to default logo
          localStorage.removeItem("domainLogo");
        }
      }
    } catch (error) {
      if (error.response) {
        const errorMessage = error.response.data.Message;
        if (errorMessage === "Invalid Credentials") {
          // this.displayError('Invalid email or password.', 'alert-no', 10000);
        } else if (
          errorMessage ===
          "Your account has been blocked. Please check your email for verification code."
        ) {
          // this.displayError('Your account has been blocked. Check your email for a verification code.', 'alert-no', 10000);
        } else {
          // this.displayError(error.response.data.msg, 'alert-no', 10000);
        }
      }
    }
  },
};
</script>
<style lang="scss" scoped>
@use "../../assets/scss/tailwinds.scss";
.cursor {
  display: inline-block;
  width: 10px;
  height: 20px;
  background-color: red;
  animation: blink 1s step-start infinite;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}

/* Auth Factor Selection Cards */
.auth-factor-card {
  border: 1.5px solid #e5e7eb;
  margin-top: 15px;
  border-radius: 12px;
  padding: 1.25rem;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fff;
}

.auth-factor-card:hover {
  border-color: #0bbbc4;
}

.auth-factor-card-active {
  border-color: #0bbbc4;
  background: linear-gradient(
    to right,
    rgba(11, 187, 196, 0.05),
    rgba(11, 187, 196, 0.02)
  );
  box-shadow: 0 4px 12px rgba(11, 187, 196, 0.2);
}

.auth-factor-card-content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.auth-factor-icon {
  width: 60px;
  height: 60px;
  background: #0bbbc4;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.auth-factor-card-active .auth-factor-icon {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(11, 187, 196, 0.4);
}

.auth-factor-icon i {
  color: #fff;
}

.auth-factor-info {
  flex: 1;
  text-align: left;
}

.auth-factor-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #132b4d;
  margin-bottom: 0.25rem;
}

.auth-factor-description {
  font-size: 0.875rem;
  color: #6b7280;
  line-height: 1.5;
  margin: 0;
}

.auth-factor-check {
  flex-shrink: 0;
  opacity: 0;
  transition: all 0.3s ease;
}

.auth-factor-card-active .auth-factor-check {
  opacity: 1;
}

.auth-factor-check i {
  font-size: 1.5rem;
  color: #0bbbc4;
}

/* Responsive adjustments */
@media (max-width: 640px) {
  .auth-factor-card-content {
    flex-direction: column;
    text-align: center;
  }

  .auth-factor-info {
    text-align: center;
  }

  .auth-factor-check {
    order: -1;
  }
}
</style>
